import { useCallback } from 'react';

import { useStoredBoolean } from './use-stored-boolean';

export type DismissibleStorage = {
  dismissed: boolean;
  dismiss: () => void;
};

export const useDismissibleStorage = (key: string): DismissibleStorage => {
  const [dismissed, setDismissed] = useStoredBoolean(key);

  const dismiss = useCallback(() => setDismissed(true), [setDismissed]);

  return { dismissed, dismiss };
};
